import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/RegisterForm";
import InvoicePreview from "./components/InvoicePreview";
import { AuthProvider } from "./utils/useAuth";
import PrivateRoute from "./utils/PrivateRoute";
import AdminRoute from "./utils/AdminRoute";
import WaitingActivation from "./components/WaitingActivation";
import DashboardAdmin from "./components/DashboardAdmin";
import NotFound from "./components/NotFound";
import Navbar from "./components/Navbar";
import DashboardUser from "./components/DashboardUser";
import { Navigate } from "react-router-dom";
import IssuedInvoices from "./components/IssuedInvoices";
import DraftsList from "./components/DraftsList";
import DraftEditor from "./components/DraftEditor";
import AllegroClients from "./components/AllegroClients";


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/waiting-activation" element={<WaitingActivation />} />
          <Route path="/dashboard" element={<PrivateRoute><DashboardUser /></PrivateRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/preview" element={<PrivateRoute><InvoicePreview /></PrivateRoute>} />
          <Route path="/admin" element={<AdminRoute><DashboardAdmin /></AdminRoute>} />
          <Route path="/issued" element={<PrivateRoute><IssuedInvoices /></PrivateRoute>} />
          <Route path="*" element={<NotFound />} />
          <Route path="/drafts" element={<PrivateRoute><DraftsList/></PrivateRoute>} />
          <Route path="/drafts/:id/edit" element={<PrivateRoute><DraftEditor /></PrivateRoute>} />
          {/* Unified Ads Clients (Allegro + Google Ads) */}
          <Route path="/allegro-clients" element={<AllegroClients />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}


export default App;
